import { Redirect } from 'expo-router';

/** Home owns the complete member and admin event feed. */
export default function LegacyAdminEventsRedirect() {
  return <Redirect href="/app/home" />;
}
